import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <p className="pbodyfont_modified">Involve others if possible, to
                                                agree the top three to haveve goals, and then prioritise
                                                them. In order to temper ideas you could ensure someone
                                                always plays ‘devil’s advocate’ – challenging or testing
                                                suggestions before acceptance.</p>
                                            <span className="greennumberroundbg_green"
                                                  style={{fontFamily:'Berthold Akzidenz Grotesk Regular'}}>O</span><span
                                            className="greensubtitle3">pportunities</span>
                                            <p className="pbodyfont_modified"  style={{clear: 'both'}}>In addition to the benefits
                                                and opportunities of the overall goal, consider what each
                                                person involved has to gain from the process of working
                                                towards it, including development opportunities, reward and
                                                recognition. Examine how you will delegate tasks and the
                                                potential opportunities
                                                they offer – see the tool ‘How to delegate’ for more advice
                                                on this subject.</p>
                                            <p className="pbodyfont_modified">Finally, consider your own
                                                gains including development, an improved profile in the
                                                organisation and increased self-esteem.</p>
                                            <span className="greennumberroundbg_green"
                                                  style={{fontFamily:'Berthold Akzidenz Grotesk Regular'}}>R</span><span
                                            className="greensubtitle3">isks</span>
                                            <p className="pbodyfont_modified"  style={{clear: 'both'}}>Differentiate between the
                                                strategy’s perceived and actual risks or threats. Consult
                                                with others if necessary to find
                                                ways of offsetting them. Make these preparations known to
                                                mitigate concern and strengthen support for the
                                                strategy.</p>
                                            <p className="pbodyfont_modified">Using the list of prioritised
                                                actions, identify their foremost ‘issues’. Make sure you
                                                continue to do this as your
                                                plan progresses – and especially in the short to medium
                                                term; that is, the next couple of months or year.</p>
                                            <p className="pbodyfont_modified">Of potential risk to all
                                                strategies is how people manage and deal with change.
                                                Consider how complex the tasks are
                                                and how this will fit in with workloads, or otherwise affect
                                                people. How you manage change for yourself and others is
                                                critical to maintaining
                                                commitment and momentum. To this end, manage the impact of
                                                change by giving information and feedback during the
                                                process, through regular reviews of
                                                team and individual progress.</p>
                                            <span className="greennumberroundbg_green"
                                                  style={{fontFamily:'Berthold Akzidenz Grotesk Regular'}}>T</span><span
                                            className="greensubtitle3">imelines</span>
                                            <p className="pbodyfont_modified" style={{clear: 'both'}}>Consider your plan in a
                                                broader context. For example, keep an eye on what’s going on
                                                in the marketplace and factor in
                                                economic and societal trends, competitor activity and new
                                                developments. You could use a model such as PEST(LE)<a
                                                    href="further_info.php?course=300"><sup>3</sup></a> to
                                                help focus your thoughts here.
                                                Also, think about the internal position and how this may
                                                affect your strategy by considering: Where is the
                                                organisation heading? What will the
                                                situation look like in the future?</p>
                                            <p className="pbodyfont_modified">Think about aspects such as
                                                timescales, resources which might be needed (people – role
                                                modelling, money, time, your own personal qualities of
                                                perseverance, etc.) and financial requirements. Make this as
                                                definitive as possible – the S.M.A.R.T. technique<a
                                                    href="further_info.php?course=300"><sup>4</sup></a> for
                                                goal setting will be useful.
                                                Make your goals specific, realistic and measurable – and
                                                explain why they’re worthwhile. Celebrate achievements along
                                                the way. How will you know
                                                what these smaller achievements are? How will you get
                                                feedback to use as evidence of them?</p>
                                            <p className="pbodyfont_modified">If you follow these simple
                                                rules, your strategic goal setting process will be much more
                                                successful and your overall performance will improve.</p>
                                            <div className="uiheading"><p className="pbodyfont_modified"
                                                                          style={{paddingBottom:'0px !important'}}>The
                                                following pages outline three practical tools to help you to
                                                develop strategic long-term goals:</p></div>
                                            <div className="indicatorlist_new">
                                                <ul>
                                                    <li>Strategic Goal Setting Checklist</li>
                                                    <li>Common Barriers to Success and Remedy Advice</li>
                                                    <li>V-SPORT Self-Analysis.</li>
                                                </ul>
                                            </div>
                                            <div className="circle_title">
                                                <div className="circle_title bulletdot"><img
                                                    src={require('@images/greendot.jpg')}
                                                    alt=""/>Strategic goal setting checklist
                                                </div>
                                                <p className="pbodyfont_modified"
                                                   style={{textTransform: 'none'}}>To help you ensure you’re
                                                    covering all the important aspects of developing
                                                    strategic goals, you
                                                    could use this checklist (print it out if it’s easier).
                                                    It conforms with the ‘V-SPORT’ model outlined
                                                    earlier.</p>

                                            </div>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}